import { Space } from "antd"
import { NavLink } from "react-router-dom"

import { IUser } from "@/types/IUser"
import { ITableColumn } from "@/types/ui"

import { paths } from "@/router/paths"


export const employeesColumns: ITableColumn<IUser>[] = [
  {
    title: "Номер записи",
    key: "id",
    dataIndex: ["id"],
    sorter: true,
    width: 200,
    isVisible: false,
    order: 1
  },
  {
    title: "Логин",
    key: "login",
    dataIndex: ["login"],
    sorter: true,
    defaultSortOrder: "ascend",
    width: 200,
    isVisible: true,
    order: 2
  },
  {
    title: "Имя",
    key: "firstName",
    dataIndex: ["firstName"],
    sorter: true,
    isVisible: true,
    order: 3
  },
  {
    title: "Фамилия",
    key: "lastName",
    dataIndex: ["lastName"],
    sorter: true,
    isVisible: true,
    order: 4
  },
  {
    title: "Электронная почта",
    key: "email",
    dataIndex: ["email"],
    sorter: true,
    isVisible: true,
    order: 5
  },
  {
    title: "Телефон",
    key: "phone",
    dataIndex: ["phone"],
    sorter: true,
    render: (_, user: IUser) => user.phone ? `+7 ${user.phone}` : "-",
    isVisible: true,
    order: 6
  },
  {
    title: "Роли",
    key: "roles",
    dataIndex: ["roles"],
    align: "center",
    render: (_, user: IUser) => (
      <>
        <Space direction="vertical" size="small" >
          {
            user.roles &&
            user.roles.map((role) => {
              return (
                <span >{role.description}</span>
              )
            })
          }
        </Space>
      </>
    ),
    sorter: false,
    isVisible: true,
    order: 7
  }
]
